interface validationConfigType {
  FIELDS: string[];
  MESSAGE: { [key: string]: { [key: string]: string } };
  RULES: { [key: string]: any };
}

const useValidation = (validationConfig: validationConfigType) => {
  const { FIELDS, MESSAGE, RULES } = validationConfig;

  const validate = (formData: { [key: string]: any }) => {
    let newErrors = '';

    for (const field of FIELDS) {
      const value = formData[field];
      const rules = RULES[field] || {};
      const msgs = MESSAGE[field] || {};

      if (rules.required && !value) {
        newErrors = msgs.required;
        break;
      }

      for (const [ruleName, ruleVal] of Object.entries(rules)) {
        if (ruleName === 'required') continue;

        if (typeof ruleVal === 'function') {
          const ok = ruleVal(value, formData);
          if (!ok) return msgs[ruleName];
          continue;
        }

        if (ruleVal instanceof RegExp) {
          if (!ruleVal.test(String(value ?? ''))) {
            if (rules.nullable && (value === null || value === '')) {
              continue;
            }
            newErrors = msgs[ruleName];
            break;
          }
        }
      }
    }

    return newErrors;
  };
  return { validate };
};

export default useValidation;
